import React from "react";
import { Line } from "react-chartjs-2";
import moment from "moment";
import "../style/debtDetails.css";
export const DetailChart = (props) => {
  const chartData = [
    ...new Set(props.data && props.data.map((item) => item.amount)),
  ];
  const chartDataX = [
    ...new Set(props.data && props.data.map((item) => item.created_at)),
  ];
  let newData =
    chartDataX &&
    chartDataX.map((item) => moment(item).format("MMMM Do YYYY, h:mm:ss a"));
  console.log(newData, "propsChart");

  const data = {
    labels: newData && newData, //["$5000", "$10000", "$15000", "$20000", "$25000", "$30000"],
    datasets: [
      {
        label: "PayOff",
        data: chartData && chartData,
        fill: true,
        backgroundColor: "#E6F1FF",
        borderColor: "#2A3DA3",
      },
    ],
  };

  return (
    <div>
      <div className="cardHeading">Payoff Timeline</div>
      <div style={{ marginTop: "1rem" }}>
        <Line
          data={data}
          options={{
            legend: {
              display: false,
            },
            scales: {
              xAxes: [
                {
                  gridLines: {
                    color: "rgba(0, 0, 0, 0)",
                  },
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    color: "rgba(0, 0, 0, 0)",
                  },
                },
              ],
            },
            plugins: {},
          }}
        />
      </div>
    </div>
  );
};
